import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import { AppView } from './components/AppView';
import { ConfigOutlets } from './components/ConfigOutlets';
import { ConfigTransmitters } from './components/ConfigTransmitters';
import { ConfigZigbee } from './components/ConfigZigbee';
import { ConfigZigbeeDevice } from './components/ConfigZigbeeDevice';
import { ConfigZigbeeDeviceJson } from './components/ConfigZigbeeDeviceJson';
import { ConfigPanels } from './components/ConfigPanels';
import { ConfigPanel } from './components/ConfigPanel';
import { ConfigTransmitterSetup } from './components/ConfigTransmitterSetup';
import { ConfigSchedule } from './components/ConfigSchedule';
import { ConfigMacros } from './components/ConfigMacros';
import { ConfigSensors } from './components/ConfigSensors';
import { ConfigSessions } from './components/ConfigSessions';
import { PageDevice } from './components/PageDevice';
import { Panel } from './components/Panel';
import { Sensors } from './components/Sensors';
import { Macros } from './components/Macros';
import { Login } from './components/Login';
import { NoMatch } from './components/NoMatch';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { store } from './util/store';
import { JWT } from './components/JWT';
import { ConfigMandolynThermometers } from './components/ConfigMandolynThermometers';
import { ConfigNexaTransmitters } from './components/config/NexaTransmitter/ConfigNexaTransmitters';
import { ConfigNexaReceivers } from './components/config/NexaReceiver/ConfigNexaReceivers';
import { ConfigHastaTransmitters } from './components/config/HastaTransmitter/ConfigHastaTransmitters';
import { ConfigHastaReceivers } from './components/config/HastaReceiver/ConfigHastaReceivers';
import { ConfigDevices } from './components/ConfigDevices';
import { ConfigDevice } from './components/ConfigDevice';
const router = createBrowserRouter([
    {
        element: _jsx(App, {}), // Use App as a wrapper for all routes
        children: [
            {
                path: '/login',
                element: _jsx(Login, {}),
            },
            {
                element: _jsx(AppView, {}),
                children: [
                    { path: '/', element: _jsx(Panel, {}), },
                    { path: 'device/:id', element: _jsx(PageDevice, {}), },
                    { path: 'panel/:id', element: _jsx(Panel, {}), },
                    { path: 'sensors', element: _jsx(Sensors, {}), },
                    { path: 'macros', element: _jsx(Macros, {}), },
                    { path: '/config', children: [
                            { path: 'devices', element: _jsx(ConfigDevices, {}), },
                            { path: 'device/:id', element: _jsx(ConfigDevice, {}), },
                            { path: 'transmitter/:id/setup', element: _jsx(ConfigTransmitterSetup, {}), },
                            { path: 'transmitters', element: _jsx(ConfigTransmitters, {}), },
                            { path: 'zigbee/:id/json', element: _jsx(ConfigZigbeeDeviceJson, {}), },
                            { path: 'zigbee/:id', element: _jsx(ConfigZigbeeDevice, {}), },
                            { path: 'zigbee', element: _jsx(ConfigZigbee, {}), },
                            { path: 'panels', element: _jsx(ConfigPanels, {}), },
                            { path: 'panel/:id', element: _jsx(ConfigPanel, {}), },
                            { path: 'mandolyn-thermometers', element: _jsx(ConfigMandolynThermometers, {}), },
                            { path: 'hasta-transmitters', element: _jsx(ConfigHastaTransmitters, {}), },
                            { path: 'hasta-receivers', element: _jsx(ConfigHastaReceivers, {}), },
                            { path: 'nexa-transmitters', element: _jsx(ConfigNexaTransmitters, {}), },
                            { path: 'nexa-receivers', element: _jsx(ConfigNexaReceivers, {}), },
                            { path: 'outlet', element: _jsx(ConfigOutlets, {}), },
                            { path: 'sensors', element: _jsx(ConfigSensors, {}), },
                            { path: 'macros', element: _jsx(ConfigMacros, {}), },
                            { path: 'schedule', element: _jsx(ConfigSchedule, {}), },
                            { path: 'sessions', element: _jsx(ConfigSessions, {}), },
                        ],
                    },
                    { path: 'jwt', element: _jsx(JWT, {}), },
                    { path: '*', element: _jsx(NoMatch, {}), },
                ],
            },
        ]
    }
]);
const Main = () => (_jsx(Provider, { store: store, children: _jsx(RouterProvider, { router: router }) }));
const Root = () => _jsx(React.StrictMode, { children: _jsx(Main, {}) });
const root = createRoot(document.getElementById('root'));
root.render(_jsx(Root, {}));
